import React, { useState } from 'react';

const faqData = [
  {
    id: 1,
    question: "What types of businesses do you work with?",
    answer: "We work with businesses of all sizes across various industries including manufacturing, agriculture, construction, logistics, and distribution. No business is too small or too large for our services."
  },
  {
    id: 2,
    question: "What qualifications do your consultants have?",
    answer: "Our consultants are NEBOSH certified professionals and Chartered members of IOSH (Institution of Occupational Safety and Health). We maintain the highest standards of professional development and industry knowledge."
  },
  {
    id: 3,
    question: "Do you offer remote consultations?",
    answer: "Yes, we provide convenient Zoom-based consultations that allow us to serve clients regardless of their location. Our remote consultations are just as thorough and professional as in-person visits."
  },
  {
    id: 4,
    question: "What is included in your risk assessment reviews?",
    answer: "Our comprehensive risk assessment reviews cover legal, moral, and financial aspects of workplace safety. We identify potential hazards, evaluate risks, and provide actionable recommendations for improvement."
  },
  {
    id: 5,
    question: "How do you help with compliance requirements?",
    answer: "We provide comprehensive guidance on all relevant health and safety regulations, conduct gap analyses, and develop implementation plans to ensure your business meets all compliance requirements."
  },
  {
    id: 6,
    question: "What makes your construction and fire safety services special?",
    answer: "We specialise in construction and fire safety with extensive experience in these high-risk sectors. Our expertise ensures that your sites and facilities meet the strictest safety standards while remaining practical and efficient."
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <div className="section-header">
          <div className="section-badge">FAQ</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Get answers to common questions about our safety consultation services
          </p>
        </div>

        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div 
              key={faq.id} 
              className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            >
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">
                  {activeIndex === index ? '−' : '+'}
                </span>
              </button>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
